"use client";

import { useEffect } from "react";
import Link from "next/link";
import {
  APP_ERROR_DESCRIPTION,
  APP_ERROR_HOME_LABEL,
  APP_ERROR_RETRY_LABEL,
  APP_ERROR_TITLE,
} from "@/constants/app-error";
import { noticeBrowserError } from "@/lib/newrelic/browser";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    noticeBrowserError(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="bg-cloud text-infoplaza-black antialiased">
        <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 py-16 text-center">
          <h1 className="text-2xl font-semibold">{APP_ERROR_TITLE}</h1>
          <p className="max-w-md text-sm text-zinc-600">{APP_ERROR_DESCRIPTION}</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white"
              onClick={reset}
            >
              {APP_ERROR_RETRY_LABEL}
            </button>
            <Link
              href="/"
              className="rounded-md border border-zinc-950/10 px-4 py-2 text-sm font-semibold"
            >
              {APP_ERROR_HOME_LABEL}
            </Link>
          </div>
        </main>
      </body>
    </html>
  );
}
